import { render } from "./ArrowHeadSVG.vue?vue&type=template&id=1e314870"
const script = {}

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__